import { FC, memo } from 'react';
import { useTranslation } from 'react-i18next';
import { Badge, Box, Flex, Text } from '@chakra-ui/react';

import { ConversationListItem as Item } from '../types';

export type ConversationListItemProps = {
  conversation: Item;
  isSelected: boolean;
  onSelect: (id: number) => void;
};

export const ConversationListItem: FC<ConversationListItemProps> = memo(function ConversationListItem({
  conversation,
  isSelected,
  onSelect,
}) {
  const { i18n, t } = useTranslation();

  return (
    <Box
      as="button"
      textAlign="left"
      width="full"
      px={3}
      py={3}
      borderBottomWidth="1px"
      borderColor="neutral.200"
      bg={isSelected ? 'neutral.100' : undefined}
      _hover={{ bg: 'neutral.50' }}
      onClick={() => onSelect(conversation.id)}
    >
      <Flex justify="space-between" gap={2} align="baseline">
        <Text fontWeight={conversation.unreadCount > 0 ? 'bold' : 'medium'} noOfLines={1}>
          {/* On the contact side the other party is the advertiser, whose name we do not hold -
              naming the reader's own address there would only be confusing. */}
          {conversation.participant === 'Contact'
            ? t('messages.ownEnquiry')
            : conversation.contactName || conversation.contactEmail}
        </Text>
        {conversation.unreadCount > 0 && (
          <Badge colorScheme="primary" borderRadius="full">
            {conversation.unreadCount}
          </Badge>
        )}
      </Flex>

      {conversation.dataObjectTitle && (
        <Text fontSize="sm" color="neutral.600" noOfLines={1}>
          {conversation.dataObjectTitle}
        </Text>
      )}

      <Flex justify="space-between" gap={2} align="baseline">
        <Text fontSize="sm" color="neutral.500" noOfLines={1}>
          {conversation.lastMessageSnippet}
        </Text>
        <Text fontSize="xs" color="neutral.500" flexShrink={0}>
          {new Date(conversation.lastMessageDate).toLocaleDateString(i18n.language)}
        </Text>
      </Flex>
    </Box>
  );
});
